<template>
    <modal title="Aktivierung erfolgreich">
        <p class="ion-padding-bottom">
            Dein Aktivierungscode wurde erfolgreich eingelöst. Du erhältst
            voraussichtlich innerhalb der nächsten 15 Minuten dein
            <b>eService Passwort per SMS</b> und deine
            <b>Verfügernummer an die von dir angegebene E-Mail</b>.
        </p>
        <b>Wichtiger Sicherheitshinweis</b>
        <p>
            Bitte ändere dein Passwort, nachdem du dich eingeloggt hast. Gehe
            dazu einfach auf dein Profil und klicke im Bereich Zugangsdaten auf
            „Passwort ändern“.
        </p>
        <template v-slot:footer>
            <ion-button expand="block" @click="$ionic.modalController.dismiss()"
                >Verstanden</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";

export default {
    components: {
        Modal,
    },
    props: {},
    data() {
        return {};
    },
};
</script>

<style></style>
